import React from 'react';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import { DeliveryNote } from '../../../types';
import Input from '../Input';
import Select from '../Select';
import TextArea from '../TextArea';

interface DeliverySignaturesSectionProps {
  register: UseFormRegister<DeliveryNote>;
  errors: FieldErrors<DeliveryNote>;
  statusOptions: { value: string; label: string }[];
}

const DeliverySignaturesSection: React.FC<DeliverySignaturesSectionProps> = ({
  register,
  errors,
  statusOptions,
}) => {
  return (
    <>
      <div className="card">
        <div className="card-header">
          <h2 className="text-lg font-semibold text-gray-900">Signatures & Delivery Information</h2>
        </div>
        <div className="card-body">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="space-y-4">
              <h3 className="text-sm font-medium text-gray-700">Delivered BY:</h3>
              <div>
                <Input
                  label="Signature"
                  {...register('deliveredBy.signature')}
                  placeholder="Digital signature or initials"
                />
              </div>
              <div>
                <Input
                  label="Name"
                  {...register('deliveredBy.name', { required: 'Delivered by name is required' })}
                  error={errors.deliveredBy?.name?.message}
                  placeholder="Person who delivered"
                />
              </div>
              <div>
                <Input
                  label="Stamp"
                  {...register('stampDeliveredBy')}
                  placeholder="Official stamp"
                />
              </div>
            </div>

            <div className="space-y-4">
              <h3 className="text-sm font-medium text-gray-700">Delivered To:</h3>
              <div>
                <Input
                  label="Signature"
                  {...register('deliveredTo.signature')}
                  placeholder="Digital signature or initials"
                />
              </div>
              <div>
                <Input
                  label="Name"
                  {...register('deliveredTo.name', { required: 'Delivered to name is required' })}
                  error={errors.deliveredTo?.name?.message}
                  placeholder="Person who received"
                />
              </div>
              <div>
                <Input
                  label="Zoom / Department"
                  {...register('deliveredTo.zoom')}
                  placeholder="Department or zoom reference"
                />
              </div>
              <div>
                <Input
                  label="Stamp"
                  {...register('stampDeliveredTo')}
                  placeholder="Official stamp"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h2 className="text-lg font-semibold text-gray-900">Status & Additional Information</h2>
        </div>
        <div className="card-body">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <Select
                label="Status"
                {...register('status', { required: 'Status is required' })}
                options={statusOptions}
                error={errors.status?.message}
              />
            </div>
            <div>
              <Input
                label="Received Date"
                type="date"
                {...register('receivedDate')}
                placeholder="Date when items were received (if applicable)"
              />
            </div>
            <div className="md:col-span-2">
              <TextArea
                label="Additional Notes"
                {...register('notes')}
                rows={3}
                placeholder="Any additional notes or special instructions..."
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeliverySignaturesSection;
